module.exports = __webpack_public_path__ + "img/fcb-logo-th.ab5f99a9.png";